import React from "react";

const SUVERA_TECH_URL = "https://suveratechnologies.com/";

export function PoweredBy({ className = "" }) {
  return (
    <a
      href={SUVERA_TECH_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="powered-by-suvera"
      className={`inline-flex items-center gap-1.5 text-[11px] text-slate-400 hover:text-slate-600 transition-colors ${className}`}
    >
      <span>Powered by</span>
      <img src="/suvera-technology.webp" alt="Suvera Technology" className="h-4 w-auto object-contain" />
    </a>
  );
}
